import { get, post } from "api";

// WHO WORKS IN WHICH COMPANY - super admin only, enforced on the server
// (back/routes/adminCompanyPeople). Every change is preview -> apply, and
// an apply hands back an `undo` reference for the result notice.
//
// `get` resolves error bodies instead of throwing, so the reads throw here:
// a 403 must read as "not allowed", never as an empty company.
const orThrow = (res) => {
  if (!res || res.err) throw res || { err: "No answer from the server" };
  return res;
};

export const getCompanyPeople = (companyId) =>
  get(`/admin/company-people/companies/${companyId}/people`).then(orThrow);

export const searchPeople = (q, companyId) =>
  get(`/admin/company-people/search?q=${encodeURIComponent(q)}&companyId=${encodeURIComponent(companyId || "")}`).then(orThrow);

// op: "add" | "remove" | "admin" | "move"
export const previewPeopleChange = (op, body) =>
  post(`/admin/company-people/${op}/preview`, body);

export const applyPeopleChange = (op, body) =>
  post(`/admin/company-people/${op}/apply`, body);

export const undoPeopleChange = (undo) =>
  post("/admin/company-people/undo", { undo });
